import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { ProfileService } from '@brightside-web/desktop/data-access/shared';
import { map } from 'rxjs';

export const guidGuard:  CanMatchFn = (route, state) => {
  const _profileService = inject(ProfileService);
  const router = inject(Router);

  return _profileService.getProfile().pipe(
    map(profile => {
      if (!profile?.guid) {
        return router.parseUrl('/eligibility');
      }
      return true;
    }),
  );
}
